// import React, { useState, useEffect, useCallback } from "react";
// import { useNavigate } from "react-router-dom";
// import perfume1 from "../Assest/images/perfume5.webp";
// import perfume2 from "../Assest/images/Perfume8.jpg";
// import perfume3 from "../Assest/images/perfume6.jpg";
// import perfume4 from "../Assest/images/perfume4.jpg";
// import perfume5 from "../Assest/images/hero3.jpg";
// import perfume6 from "../Assest/images/perfume2.webp";
// import Logo from "../Assest/images/Rayaness.png";
// import Loader from "../components/Loader";
// import axios from "axios";

// const Branding = ({data}) => {
//   console.log(data);

//   const [flippedCard, setFlippedCard] = useState(null);
//   const navigate = useNavigate();
//   const [isLoading, setIsLoading] = useState(false);

//   const categories = [
//     {
//       id: 1,
//       title: "Women's Style",
//       subtitle: "New Arrivals",
//       description: "Up to 70% Off",
//       buttonText: "Shop Now",
//       bgColor: "bg-gray-200",
//       companyId: 13,
//       size: "lg:col-span-2 col-span-full row-span-1",
//       imageUrl: perfume1,
//       flipped: false,
//     },
//     {
//       id: 2,
//       title: "Handbag",
//       subtitle: "30% Off",
//       description: "Luxury Collections",
//       buttonText: "Shop Now",
//       bgColor: "bg-amber-100",
//       companyId: 15,
//       size: "lg:col-span-1 md:col-span-2 col-span-full row-span-1",
//       imageUrl: perfume2,
//       flipped: false,
//     },
//     {
//       id: 3,
//       title: "Watch",
//       subtitle: "25% Off",
//       description: "Premium Selection",
//       buttonText: "Shop Now",
//       bgColor: "bg-gray-100",
//       companyId: 16,
//       size: "lg:col-span-1 md:col-span-2 col-span-full row-span-1",
//       imageUrl: perfume3,
//       flipped: false,
//     },
//     {
//       id: 4,
//       title: "Watch",
//       subtitle: "25% Off",
//       description: "Limited Edition",
//       buttonText: "Shop Now",
//       bgColor: "bg-gray-100",
//       companyId: 14,
//       size: "lg:col-span-1 md:col-span-2 col-span-full row-span-1",
//       imageUrl: perfume4,
//       flipped: false,
//     },
//     {
//       id: 5,
//       title: "Watch",
//       subtitle: "25% Off",
//       description: "Exclusive Designs",
//       buttonText: "Shop Now",
//       bgColor: "bg-gray-100",
//       companyId: 12,
//       size: "lg:col-span-1 md:col-span-2 col-span-full row-span-1",
//       imageUrl: perfume5,
//       flipped: false,
//     },
//     {
//       id: 6,
//       title: "Backpack",
//       subtitle: "Accessories",
//       description: "Min. 40-60% Off",
//       buttonText: "Shop Now",
//       bgColor: "bg-amber-200",
//       companyId: 13,
//       size: "lg:col-span-2 col-span-full row-span-1",
//       imageUrl: perfume6,
//       flipped: false,
//     },
//   ];

//   useEffect(() => {
//     const interval = setInterval(() => {
//       const nextCard =
//         flippedCard === null ? 0 : (flippedCard + 1) % categories.length;
//       setFlippedCard(nextCard);
//     }, 3000);

//     return () => clearInterval(interval);
//   }, [flippedCard, categories.length]);

//   const handleMouseEnter = (index) => {
//     setFlippedCard(index);
//   };

//   const handleMouseLeave = () => {
//     // Optional: You can comment this out if you want the card to stay flipped
//     // when the mouse leaves
//   };
//   const handleShopNow = useCallback(async (companyId) => {
//     try {
//       setIsLoading(true);
//       const response = await axios.get(`${process.env.REACT_APP_API_URI}/products/company/${companyId}`);
//       if (response.status === 200) {
//         localStorage.setItem('apiProducts', JSON.stringify(response.data));

//         navigate(`/product`, {
//           state: {
//             apiData: response.data,
//             companyId: companyId
//           }
//         });
//       }
//     } catch (error) {
//       console.error("Error fetching company ", error);
//     } finally {
//       setIsLoading(false);
//     }
//   }, [navigate]);

//   return (
//     <>
//     <div className="max-w-6xl mx-auto p-4">
//       {isLoading && <Loader Logo={Logo} />}
//       <div className="grid grid-cols-4 gap-4">
//         {categories.map((category, index) => (
//           <div
//             key={category.id}
//             className={`${category.size} relative overflow-hidden rounded-lg shadow-lg h-64 sm:h-72 md:h-80 perspective-1000`}
//             onMouseEnter={() => handleMouseEnter(index)}
//             onMouseLeave={handleMouseLeave}
//           >
//             {/* Flip card container */}
//             <div
//               className={`relative w-full h-full transition-transform duration-700 transform-style-3d ${flippedCard === index ? "rotate-y-180" : ""
//                 }`}
//             >
//               {/* Front of card */}
//               <div className="absolute w-full h-full backface-hidden">
//                 <div className="relative h-full w-full overflow-hidden">
//                   {/* Background image covering the entire card */}
//                   <img
//                     src={category.imageUrl}
//                     alt={category.title}
//                     className="absolute h-full w-full object-cover"
//                   />

//                   {/* Overlay to make text more readable */}
//                   <div className="absolute inset-0 bg-black bg-opacity-20"></div>

//                   {/* Content */}
//                   <div className="absolute inset-0 flex flex-col justify-center p-6 text-white">
//                     <span className="inline-block w-[100px] px-2 py-1 bg-[#ea580c] text-white text-xs font-semibold rounded mb-2">
//                       {category.subtitle}
//                     </span>
//                     <h2 className="text-2xl md:text-3xl font-bold mb-2 drop-shadow-md">
//                       {category.title}
//                     </h2>
//                     {category.description && (
//                       <p className="text-sm md:text-base mb-4 drop-shadow-md">
//                         {category.description}
//                       </p>
//                     )}
//                     <button onClick={() => handleShopNow(category.companyId)} className="mt-2 inline-block w-max bg-white bg-opacity-90 text-gray-800 px-4 py-2 rounded-full font-medium hover:bg-opacity-100 transition duration-300 transform hover:scale-105">
//                       {category.buttonText} →
//                     </button>
//                   </div>
//                 </div>
//               </div>

//               {/* Back of card */}
//               <div className="absolute w-full h-full backface-hidden rotate-y-180">
//                 <div className="h-full w-full relative overflow-hidden">
//                   {/* Background image with blur effect */}
//                   <img
//                     src={category.imageUrl}
//                     alt={category.title}
//                     className="absolute h-full w-full object-cover filter blur-sm scale-110"
//                   />

//                   {/* Colored overlay */}
//                   <div className="absolute inset-0 bg-black bg-opacity-40"></div>

//                   {/* Content */}
//                   <div className="relative h-full w-full flex flex-col justify-center items-center text-center p-6 text-white">
//                     <h3 className="text-xl md:text-2xl font-bold mb-2">
//                       {category.title}
//                     </h3>
//                     <p className="text-sm text-gray-200 mb-4">
//                       Exclusive Collection
//                     </p>
//                     <p className="mb-4 text-md max-w-xs">
//                       {category.description || "Limited time offer. Don't miss out on these incredible deals!"}
//                     </p>
//                     <button onClick={() => handleShopNow(category.companyId)} className="bg-white text-gray-800 px-6 py-2 rounded-full font-medium hover:bg-gray-100 transition-all duration-300 transform hover:scale-105">
//                       {category.buttonText}
//                     </button>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         ))}
//       </div>
//     </div>
//      <style jsx global>{`
//       .perspective-1000 {
//         perspective: 1000px;
//       }

//       .transform-style-3d {
//         transform-style: preserve-3d;
//       }

//       .backface-hidden {
//         backface-visibility: hidden;
//       }

//       .rotate-y-180 {
//         transform: rotateY(180deg);
//       }
//     `}</style>
//     </>
//   );
// };

// export default Branding;

import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import perfume1 from "../Assest/images/perfume5.webp";
import perfume2 from "../Assest/images/Perfume8.jpg";
import perfume3 from "../Assest/images/perfume6.jpg";
import perfume4 from "../Assest/images/perfume4.jpg";
import perfume5 from "../Assest/images/hero3.jpg";
import perfume6 from "../Assest/images/perfume2.webp";
import Logo from "../Assest/images/Rayaness.png";
import Loader from "../components/Loader";
import axios from "axios";

const Branding = ({ data }) => {

  const [flippedCard, setFlippedCard] = useState(null);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const categories = [
    {
      id: 1,
      title: "Floral Collection",
      subtitle: "New Arrivals",
      description: "Up to 70% Off on Premium Floral Fragrances",
      buttonText: "Shop Now",
      bgColor: "bg-gray-200",
      companyId: 13,
      size: "lg:col-span-2 col-span-full row-span-1",
      imageUrl: perfume1,
      flipped: false,
    },
    {
      id: 2,
      title: "Oriental Scents",
      subtitle: "30% Off",
      description: "Exotic Perfumes from the East",
      buttonText: "Shop Now",
      bgColor: "bg-amber-100",
      companyId: 15,
      size: "lg:col-span-1 md:col-span-2 col-span-full row-span-1",
      imageUrl: perfume2,
      flipped: false,
    },
    {
      id: 3,
      title: "Woody Fragrances",
      subtitle: "25% Off",
      description: "Cedar, Sandalwood & Vetiver Notes",
      buttonText: "Shop Now",
      bgColor: "bg-gray-100",
      companyId: 16,
      size: "lg:col-span-1 md:col-span-2 col-span-full row-span-1",
      imageUrl: perfume3,
      flipped: false,
    },
    {
      id: 4,
      title: "Fresh Citrus",
      subtitle: "Summer Special",
      description: "Refreshing Lemon & Bergamot Scents",
      buttonText: "Shop Now",
      bgColor: "bg-gray-100",
      companyId: 14,
      size: "lg:col-span-1 md:col-span-2 col-span-full row-span-1",
      imageUrl: perfume4,
      flipped: false,
    },
    {
      id: 5,
      title: "Luxury Oud",
      subtitle: "Premium Collection",
      description: "Rare & Exquisite Middle Eastern Accords",
      buttonText: "Shop Now",
      bgColor: "bg-gray-100",
      companyId: 12,
      size: "lg:col-span-1 md:col-span-2 col-span-full row-span-1",
      imageUrl: perfume5,
      flipped: false,
    },
    {
      id: 6,
      title: "Gift Sets",
      subtitle: "Special Offers",
      description: "Min. 40-60% Off on Luxury Gift Collections",
      buttonText: "Shop Now",
      bgColor: "bg-amber-200",
      companyId: 13,
      size: "lg:col-span-2 col-span-full row-span-1",
      imageUrl: perfume6,
      flipped: false,
    },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      const nextCard =
        flippedCard === null ? 0 : (flippedCard + 1) % categories.length;
      setFlippedCard(nextCard);
    }, 3000);

    return () => clearInterval(interval);
  }, [flippedCard, categories.length]);

  const handleMouseEnter = (index) => {
    setFlippedCard(index);
  };

  const handleMouseLeave = () => {
    // Optional: You can comment this out if you want the card to stay flipped
    // when the mouse leaves
  };
  const handleShopNow = useCallback(
    async (companyId) => {
      try {
        setIsLoading(true);
        const response = await axios.get(
          `${process.env.REACT_APP_API_URI}/products/company/${companyId}`
        );
        if (response.status === 200) {
          localStorage.setItem("apiProducts", JSON.stringify(response.data));

          navigate(`/product?id=${companyId}`, {
            state: {
              apiData: response.data,
              companyId: companyId,
            },
          });
        }
      } catch (error) {
        console.error("Error fetching company ", error);
      } finally {
        setIsLoading(false);
      }
    },
    [navigate]
  );

  return (
    <>
      <div className="max-w-6xl mx-auto p-4">
        {isLoading && <Loader Logo={Logo} />}
        <div className="grid grid-cols-4 gap-4">
          {categories.map((category, index) => (
            <div
              key={category.id}
              className={`${category.size} relative overflow-hidden rounded-lg shadow-lg h-64 sm:h-72 md:h-80 perspective-1000`}
              onMouseEnter={() => handleMouseEnter(index)}
              onMouseLeave={handleMouseLeave}
            >
              {/* Flip card container */}
              <div
                className={`relative w-full h-full transition-transform duration-700 transform-style-3d ${
                  flippedCard === index ? "rotate-y-180" : ""
                }`}
              >
                {/* Front of card */}
                <div className="absolute w-full h-full backface-hidden">
                  <div className="relative h-full w-full overflow-hidden">
                    {/* Background image covering the entire card */}
                    <img
                      src={category.imageUrl}
                      alt={category.title}
                      className="absolute h-full w-full object-cover"
                    />

                    {/* Overlay to make text more readable */}
                    <div className="absolute inset-0 bg-black bg-opacity-20"></div>

                    {/* Content */}
                    <div className="absolute inset-0 flex flex-col justify-center p-6 text-white">
                      <span className="inline-block w-[100px] px-2 py-1 bg-[#ea580c] text-white text-xs font-semibold rounded mb-2">
                        {category.subtitle}
                      </span>
                      <h2 className="text-2xl md:text-3xl font-bold mb-2 drop-shadow-md">
                        {category.title}
                      </h2>
                      {category.description && (
                        <p className="text-sm md:text-base mb-4 drop-shadow-md">
                          {category.description}
                        </p>
                      )}
                      <button
                        onClick={() => handleShopNow(category.companyId)}
                        className="mt-2 inline-block w-max bg-white bg-opacity-90 text-gray-800 px-4 py-2 rounded-full font-medium hover:bg-opacity-100 transition duration-300 transform hover:scale-105"
                      >
                        {category.buttonText} →
                      </button>
                    </div>
                  </div>
                </div>

                {/* Back of card */}
                <div className="absolute w-full h-full backface-hidden rotate-y-180">
                  <div className="h-full w-full relative overflow-hidden">
                    {/* Background image with blur effect */}
                    <img
                      src={category.imageUrl}
                      alt={category.title}
                      className="absolute h-full w-full object-cover filter blur-sm scale-110"
                    />

                    {/* Colored overlay */}
                    <div className="absolute inset-0 bg-black bg-opacity-40"></div>

                    {/* Content */}
                    <div className="relative h-full w-full flex flex-col justify-center items-center text-center p-6 text-white">
                      <h3 className="text-xl md:text-2xl font-bold mb-2">
                        {category.title}
                      </h3>
                      <p className="text-sm text-gray-200 mb-4">
                        Signature Collection
                      </p>
                      <p className="mb-4 text-md max-w-xs">
                        {index === 0
                          ? "Experience the elegance of our rose, jasmine and lily bouquets"
                          : index === 1
                          ? "Indulge in rich amber, spice and vanilla notes"
                          : index === 2
                          ? "Discover the sophistication of our premium cedarwood blends"
                          : index === 3
                          ? "Revitalize your senses with zesty citrus and herb combinations"
                          : index === 4
                          ? "Immerse yourself in the opulence of rare Arabian oud"
                          : "Perfectly curated fragrance sets for every occasion and preference"}
                      </p>
                      <button
                        onClick={() => handleShopNow(category.companyId)}
                        className="bg-white text-gray-800 px-6 py-2 rounded-full font-medium hover:bg-gray-100 transition-all duration-300 transform hover:scale-105"
                      >
                        {category.buttonText}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <style jsx global>{`
        .perspective-1000 {
          perspective: 1000px;
        }

        .transform-style-3d {
          transform-style: preserve-3d;
        }

        .backface-hidden {
          backface-visibility: hidden;
        }

        .rotate-y-180 {
          transform: rotateY(180deg);
        }
      `}</style>
    </>
  );
};

export default Branding;
